import { useState } from "react";
import { X, ZoomIn } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    {
      // url: "https://images.unsplash.com/photo-1700774606243-e7b44df0db9f?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/inposition.jpeg",
      alt: "In position",
      span: "md:col-span-2 md:row-span-2 col-span-2 row-span-2",
    },
    {
      // url: "https://images.unsplash.com/photo-1637594619207-400eb95a3f9e?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/inaction.jpeg",
      alt: "In azione",
      span: "col-span-1 row-span-1",
    },
    {
      // url: "https://images.unsplash.com/photo-1760427144206-27d38562044f?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/obj.jpg",
      alt: "Obiettivo acquisito",
      span: "col-span-1 row-span-1",
    },
    {
      // url: "https://images.unsplash.com/photo-1713718839865-afacde27cd54?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/nighttraining.jpg",
      alt: "Allenamento Notturno",
      span: "md:col-span-2 col-span-2 row-span-2",
    },
    {
      // url: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/allghilliedup1.jpg",
      alt: "All Ghillied Up 1",
      span: "col-span-1 row-span-1",
    },
    {
      // url: "https://images.unsplash.com/photo-1534308143481-c55f00be8bd7?q=80&w=2070&auto=format&fit=crop",
      url: "/gallery/allghilliedup2.jpg",
      alt: "All Ghillied Up 2",
      span: "col-span-1 row-span-1",
    },
  ];

  return (
    <section id="galleria" className="section-tactical py-12 bg-tactical-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header ripristinato con descrizione */}
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-[2px] bg-tactical-primary" />
            <span className="font-mono text-xs text-tactical-primary tracking-widest uppercase">Galleria</span>
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl tracking-wider text-tactical-text uppercase">
            ARCHIVIO <span className="text-tactical-primary">FOTOGRAFICO</span>
          </h2>
          <p className="font-body text-tactical-text-muted mt-4 max-w-2xl">
            Istantanee dalle nostre operazioni. Adrenalina, tattica e spirito di squadra catturati in immagini.
          </p>
        </div>

        {/* Griglia Fixata */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 grid-flow-dense auto-rows-[150px] md:auto-rows-[200px]">
          {galleryImages.map((image, index) => (
            <div
              key={index}
              className={`relative overflow-hidden border border-tactical-border group cursor-pointer bg-tactical-bg ${image.span}`}
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out scale-105 group-hover:scale-100"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-tactical-bg/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-[2px]">
                <ZoomIn className="w-8 h-8 text-tactical-primary" />
              </div>

              {/* Corner Markers */}
              <div className="absolute top-2 left-2 w-3 h-3 border-t border-l border-tactical-primary opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-2 right-2 w-3 h-3 border-b border-r border-tactical-primary opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-5xl bg-black/95 border-tactical-border p-0 overflow-hidden">
          {selectedImage && (
            <div className="relative flex items-center justify-center">
              <img
                src={selectedImage.url}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[85vh] object-contain"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black to-transparent">
                <p className="text-tactical-primary font-mono text-xs uppercase tracking-[0.2em]">{selectedImage.alt}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};